import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  radioGroup: {
    marginBottom: theme.spacing(2),
  },
  radioHelperText: {
    marginTop: -theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export default function RadioGroupField({
  fieldName,
  fieldLabel,
  fieldError,
  fieldValues,
  selectedValue,
  onChange,
  onBlur,
}) {
  const classes = useStyles();

  return (
    <FormControl component="fieldset" error={!!fieldError}>
      <FormLabel component="legend">{ fieldLabel }</FormLabel>
      <RadioGroup
        name={fieldName}
        className={classes.radioGroup}
        value={selectedValue}
        onChange={(event) => {
          onChange(event);
          onBlur(event);
        }}
        row
      >
        {fieldValues.map((fieldValue) => (
          <FormControlLabel value={fieldValue.value} control={<Radio />} label={fieldValue.label} />
        ))}
      </RadioGroup>
      <FormHelperText className={classes.radioHelperText}>{fieldError}</FormHelperText>
    </FormControl>
  );
}
